import {
  getDateFormatForFrontend,
  getTimeFormatForFrontend,
} from "../../../app/Helpers/DateTimeHelper";
import { BASIC_SETTINGS, LANGUAGE } from "../../../app/Config/ApiUrl";
import { axiosGet, urlGenerator } from "../../../app/Helpers/AxiosHelper";
import { settings } from "accounting";
import { colors } from "./customize";

export default {
  state: {
    dateFormat: window.settings?.date_format
      ? getDateFormatForFrontend(window.settings.date_format)
      : "DD-MM-YYYY",
    timeFormat: window.settings?.time_format
      ? getTimeFormatForFrontend(window.settings.time_format)
      : 12,
    appSettings: window.settings ? window.settings : {},
    selectedLanguage: {},
    taskSkinTemplates: [
      {
        primarySkinColor: "#f8f9ff",
        secondarySkinColor: "#ffffff",
        primary: "#6366f1",
        textColor: "#1e293b",
        borderColor: "#e2e8f0",
        navColor: "#ffffff",
        navTextColor: "#64748b",
        sidebar_background: "#1e1b4b",
        sidebar_color: "#818cf8",
        sidebar_icons_background: "#312e81",
        sidebar_icon_color: "#c7d2fe",
        nav_background: "#6366f1",
        nav_color: "#ffffff",
        internal_comment_color: "#f59e0b",
      },

      {
        primarySkinColor: "#1a1a1a",
        secondarySkinColor: "#2d2d2d",
        primary: "#10b981",
        textColor: "#e5e7eb",
        borderColor: "#374151",
        navColor: "#1f2937",
        navTextColor: "#d1d5db",
        sidebar_background: "#111827",
        sidebar_color: "#10b981",
        sidebar_icons_background: "#1f2937",
        sidebar_icon_color: "#6ee7b7",
        nav_background: "#111827",
        nav_color: "#e5e7eb",
        internal_comment_color: "#fbbf24",
      },

      {
        primarySkinColor: "#f0fdfa",
        secondarySkinColor: "#ffffff",
        primary: "#14b8a6",
        textColor: "#134e4a",
        borderColor: "#99f6e4",
        navColor: "#ffffff",
        navTextColor: "#0f766e",
        sidebar_background: "#134e4a",
        sidebar_color: "#2dd4bf",
        sidebar_icons_background: "#0f766e",
        sidebar_icon_color: "#5eead4",
        nav_background: "#fb923c",
        nav_color: "#ffffff",
        internal_comment_color: "#fb923c",
      },

      {
        primarySkinColor: "#f1f5f9",
        secondarySkinColor: "#ffffff",
        primary: "#3b82f6",
        textColor: "#334155",
        borderColor: "#cbd5e1",
        navColor: "#ffffff",
        navTextColor: "#475569",
        sidebar_background: "#1e3a8a",
        sidebar_color: "#60a5fa",
        sidebar_icons_background: "#1e40af",
        sidebar_icon_color: "#93bbfc",
        nav_background: "#3b82f6",
        nav_color: "#ffffff",
        internal_comment_color: "#f59e0b",
      },

      {
        primarySkinColor: "#fdf2f8",
        secondarySkinColor: "#ffffff",
        primary: "#ec4899",
        textColor: "#1f2937",
        borderColor: "#fbbcdb",
        navColor: "#ffffff",
        navTextColor: "#6b7280",
        sidebar_background: "#27272a",
        sidebar_color: "#f472b6",
        sidebar_icons_background: "#3f3f46",
        sidebar_icon_color: "#fbcfe8",
        nav_background: "#ec4899",
        nav_color: "#ffffff",
        internal_comment_color: "#f97316",
      },

      {
        primarySkinColor: "#ecfdf5",
        secondarySkinColor: "#ffffff",
        primary: "#059669",
        textColor: "#064e3b",
        borderColor: "#a7f3d0",
        navColor: "#ffffff",
        navTextColor: "#047857",
        sidebar_background: "#064e3b",
        sidebar_color: "#34d399",
        sidebar_icons_background: "#065f46",
        sidebar_icon_color: "#6ee7b7",
        nav_background: "#059669",
        nav_color: "#ffffff",
        internal_comment_color: "#ea580c",
      },
    ],
    languages: [],
    customizer: {
      secondarySkinColor: null,
      primarySkinColor: null,
      primaryColor: null,
      textColor: null,
      borderColor: null,
      chatImg: null,
      navColor: null,
      navTextColor: null,
      sidebar_background: null,
      sidebar_color: null,
      sidebar_icons_background: null,
      sidebar_icon_color: null,
      nav_background: null,
      nav_color: null,
    },
  },

  getters: {
    appSettings: (state) => state.appSettings,
    accountcustomizer: (state) => state.customizer,
  },

  mutations: {
    SET_SETTINGS(state, setting) {
      state.appSettings = setting;

      if (setting.whitelabel_domain) {
        state.appSettings.whitelabel_domain =
          setting.whitelabel_domain.split(".")[0];
      }
      state.appSettings.logo = setting?.company_logo;
      state.appSettings.icon = setting?.company_icon;

      state.appSettings.company_icon = setting?.company_icon;
      state.appSettings.company_logo = setting?.company_logo;
      state.appSettings.company_banner = setting?.company_banner;
      if (window.settings?.date_format)
        state.dateFormat = getDateFormatForFrontend(setting?.date_format);
      if (window.settings?.time_format)
        state.timeFormat = getTimeFormatForFrontend(setting?.time_format);
    },

    SET_LANGUAGES(state, data) {
      state.languages = data.map((lang) => {
        return {
          ...lang,
          id: lang.key,
          value: lang.title,
        };
      });
    },

    SET_SELECTED_LANGUAGE(state, rootState) {
      const { locale, translations } = rootState.i18n;
      state.selectedLanguage = translations[locale];
    },

    setCustomizationOptions(state, data) {
      this.commit("updateSkinPrimary", data.primarySkinColor);
      this.commit("updateSkinSecondary", data.secondarySkinColor);
      this.commit("updateTextColor", data.textColor);
      this.commit("updateNavColor", data.navColor);
      this.commit("updateNavTextColor", data.navTextColor);
      this.commit("updatePrimaryColor", data.primary);
      this.commit("updateBorderColor", data.borderColor);

      this.commit("updateSidebarBackground", data.sidebar_background);
      this.commit("updateSidebarColor", data.sidebar_color);
      this.commit(
        "updateSidebarIconsBackground",
        data.sidebar_icons_background
      );
      this.commit("updateSidebarIconColor", data.sidebar_icon_color);
      this.commit("updateNavBackground", data.nav_background);
      this.commit("updateNavColor", data.nav_color);
      this.commit("updateInternalCommentColor", data.internal_comment_color);
    },

    updateCustomization(state, data) {
      state.customizer = data;
      window.localStorage.setItem("customizationOptions", JSON.stringify(data));
    },

    updateSkinPrimary(state, val) {
      if (val) {
        document.documentElement.style.setProperty(
          "--app-background-color",
          val
        );
        document.documentElement.style.setProperty("--primarySkin", val);
      }
    },

    updateSkinSecondary(state, val) {
      //state.customizer.secondarySkinColor = val;

      if (val) {
        document.documentElement.style.setProperty("--default-card-bg", val);
        document.documentElement.style.setProperty(
          "--vertical-tab-header-bg",
          val
        );
        document.documentElement.style.setProperty("--secondarySkin", val);
        document.documentElement.style.setProperty("--calendar-bg", val);
        document.documentElement.style.setProperty("--btn-filter-bg", val);

        document.documentElement.style.setProperty(
          "--modal-header-footer-bg",
          val
        );
        document.documentElement.style.setProperty("--modal-body-bg", val);
      }
    },

    updateTextColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--default-font-color", val);
      } else {
        // document.documentElement.style.setProperty("--textColor", '#6c757d');
      }
    },

    updateNavColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--navColor", val);
        //document.documentElement.style.setProperty("--primary", val);
      } else {
        //  document.documentElement.style.setProperty("--navColor", '#ffffff');
      }
    },

    updateNavTextColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--navTextColor", val);
      } else {
        // document.documentElement.style.setProperty("--navTextColor", '#6c757d');
      }
    },

    updateBorderColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--borderColor", val);
        document.documentElement.style.setProperty("--btn-filter-bg", val);
        document.documentElement.style.setProperty(
          "--default-border-color",
          val
        );
      } else {
        //document.documentElement.style.setProperty("--borderColor", '#ebe9f1');
      }
    },

    updatePrimaryColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--primary", val);

        // Convert hex to RGB for rgba usage
        const hex = val.replace("#", "");
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        document.documentElement.style.setProperty(
          "--primary-rgb",
          `${r}, ${g}, ${b}`
        );
      }
    },

    updateSidebarBackground(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--sidebar_background", val);
      }
    },

    updateSidebarColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--sidebar_color", val);
        document.documentElement.style.setProperty("--accent-clr", val);
      }
    },

    updateSidebarIconsBackground(state, val) {
      if (val) {
        document.documentElement.style.setProperty(
          "--sidebar_icons_background",
          val
        );
      }
    },

    updateSidebarIconColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--sidebar_icon_color", val);
      }
    },

    updateNavBackground(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--nav_background", val);
      }
    },

    updateNavColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty("--nav_color", val);
      }
    },

    updateInternalCommentColor(state, val) {
      if (val) {
        document.documentElement.style.setProperty(
          "--internal-comment-color",
          val
        );
      }
    },
  },

  actions: {
    getSettings({ commit }) {
      axiosGet(BASIC_SETTINGS).then(({ data }) => {
        commit("SET_SETTINGS", data);
      });
    },

    getLanguages({ commit, state }) {
      if (!state.languages.length) {
        axiosGet(LANGUAGE).then(({ data }) => {
          commit("SET_LANGUAGES", data);
        });
      }
    },

    setSelectedLanguage({ commit, rootState }) {
      commit("SET_SELECTED_LANGUAGE", rootState);
    },

    async getConfig({ commit, state, dispatch }) {
      // dispatch("changeConfig", { skinConfiguration: state.skinTemplates[4] });
      axios.get("/app/get-customisation").then(
        ({ data }) => {
          commit("updateCustomization", data);
          // commit("updateCustomization", state.skinTemplates[0]);// data);
          commit("setCustomizationOptions", data);
        },
        (err) => {
          console.log(err);
        }
      );
    },

    async changeConfig({ commit }, data) {
      // console.log("in changeConfig ", data);
      const input = { ...data };
      const { skinConfiguration, is_main } = input;

      if (skinConfiguration) {
        const {
          primarySkinColor,
          secondarySkinColor,
          primary,
          textColor,
          borderColor,
          navColor,
          navTextColor,
          sidebar_background,
          sidebar_color,
          sidebar_icons_background,
          sidebar_icon_color,
          nav_background,
          nav_color,
          internal_comment_color,
        } = skinConfiguration;

        commit("updateSkinPrimary", primarySkinColor);
        commit("updateSkinSecondary", secondarySkinColor);
        commit("updatePrimaryColor", primary);

        commit("updateTextColor", textColor);
        commit("updateBorderColor", borderColor);
        commit("updateNavColor", navColor);
        commit("updateNavTextColor", navTextColor);

        commit("updateSidebarBackground", sidebar_background);
        commit("updateSidebarColor", sidebar_color);
        commit("updateSidebarIconsBackground", sidebar_icons_background);
        commit("updateSidebarIconColor", sidebar_icon_color);
        commit("updateNavBackground", nav_background);
        commit("updateNavColor", nav_color);
        commit("updateInternalCommentColor", internal_comment_color);
      } else {
        commit("updateSkinPrimary", colors.primarySkinColor);
        commit("updateSkinSecondary", colors.secondarySkin);
        commit("updatePrimaryColor", colors.primary);
        commit("updateTextColor", colors.textColor);
        commit("updateBorderColor", colors.borderColor);
        commit("updateNavColor", colors.navColor);
        commit("updateNavTextColor", colors.navTextColor);

        commit("updateSidebarBackground", colors.sidebar_background);
        commit("updateSidebarColor", colors.sidebar_color);
        commit("updateSidebarIconsBackground", colors.sidebar_icons_background);
        commit("updateSidebarIconColor", colors.sidebar_icon_color);
        commit("updateNavBackground", colors.nav_background);
        commit("updateNavColor", colors.nav_color);
      }

      if (is_main) {
        axios.post("/update-customisation", data.skinConfiguration).then(
          ({ data }) => {
            commit("updateCustomization", data);
            // window.localStorage.setItem(
            //   "customizationOptions",
            //   JSON.stringify(data)
            // );
          },
          (err) => {
            console.log(err);
            //log thi error
          }
        );
      }
      // try {
      //   const ag = await API.graphql(
      // 	graphqlOperation(updateAgency, {
      // 	  input,
      // 	})
      //   );
      //   if (ag.data.updateAgency) {
      // 	dispatch("SET_SKIN_CONFIG", ag.data.updateAgency.skinConfiguration, {
      // 	  root: true,
      // 	});
      //   }
      // } catch (err) {
      //   //
      // }
    },

    updateConfig({ commit }, config) {
      const {
        primarySkinColor,
        secondaryColor,
        primaryColor,
        chatBgColor,
        chatBg,
        textColor,
        borderColor,
        navColor,
        navTextColor,
        sidebar_background,
        sidebar_color,
        sidebar_icons_background,
        sidebar_icon_color,
        nav_background,
        nav_color,
      } = config;

      commit("updateSkinPrimary", primarySkinColor || colors.primarySkinColor);
      commit("updateSkinSecondary", secondaryColor || colors.secondarySkin);
      commit("updatePrimaryColor", primaryColor || colors.primary);
      commit("updateChatBackground", chatBgColor || colors.chatBgColor);
      commit("updateTextColor", textColor || colors.textColor);
      commit("updateBorderColor", borderColor || colors.borderColor);
      commit("updateNavColor", navColor || colors.navColor);
      commit("updateNavTextColor", navTextColor || colors.navTextColor);

      commit(
        "updateSidebarBackground",
        sidebar_background || colors.sidebar_background
      );
      commit("updateSidebarColor", sidebar_color || colors.sidebar_color);
      commit(
        "updateSidebarIconsBackground",
        sidebar_icons_background || colors.sidebar_icons_background
      );
      commit(
        "updateSidebarIconColor",
        sidebar_icon_color || colors.sidebar_icon_color
      );
      commit("updateNavBackground", nav_background || colors.nav_background);
      commit("updateNavColor", nav_color || colors.nav_color);
    },
  },
};
